// extracted by css-extract-rspack-plugin
export default {"form":"_63dc79f5","dropdownWrapper":"_9b9b76b","mobileScrollable":"_59bd38a4"};